import styled from 'styled-components';

export const Container = styled.div`
  z-index: 9999;
  position: fixed;
  right: 0;
  top: 0;
  padding: 80px 10px;
  overflow: hidden;
`;
